export default __webpack_public_path__ + "static/media/rari.5e37edec.png";